<div class="inline-png-checkbox text-center">
    <p-checkbox [(ngModel)]="notificacion_email" [binary]="true" [disabled]="true"></p-checkbox>
</div>
